export default __webpack_public_path__ + "static/media/socialexperience_icon.4299c6c47e8950baebe141a6759ae07f.svg";